/** Pixen Intrigue — overridden homepage copy (courtly-fae voice). */
export const homePixEn = {
  'home.seoTitle': 'Every Whisper a Weapon',
  'home.seoDescription':
    'A tabletop RPG of faerie-court intrigue and social scheming, powered by SRD 5.2.1. Trade in secrets and survive the courts of the fae.',
  'home.heroEyebrow': 'A Game of Fae Courts & Secrets',
  'home.heroTitle': 'Every Whisper a Weapon',
  'home.heroBody':
    'Navigate the glittering, treacherous courts of the fae. Trade secrets, forge alliances, and outmaneuver rivals where every whisper is a weapon.',
  'home.heroBrowseCta': 'Browse the Archive',
  'home.heroQuickstartPrompt': 'Not ready to scheme? Get the free Quickstart',

  // TodayInGrymwyrd
  'home.today.heading': 'Today at Court',

  // LiveFeed
  'home.liveFeed.heading': 'Whispers from the Salon',
  'home.liveFeed.badge': 'recent gossip',
  'home.liveFeed.loading': 'Listening at the door…',
  'home.liveFeed.actorFallback': 'A courtier',
  'home.liveFeed.actionFallback': 'traded a secret',
  'home.liveFeed.labelBestiary': 'New rival recorded',
  'home.liveFeed.labelBook': 'Tome updated',
  'home.liveFeed.empty': 'The Salon has gone quiet. No fresh gossip stirs tonight.',

  // FeaturedBooks
  'home.featuredBooks.heading': 'Featured Tomes',
  'home.featuredBooks.loading': 'Unsealing the Ledger…',
  'home.featuredBooks.descriptionFallback': 'A tome of court secrets from the Hollow Court.',

  // QuickTools
  'home.quickTools.arsenalTitle': 'The Full Repertoire',
  'home.quickTools.arsenalBody':
    'Maps, the Archive, the dice tower and the living chronicle await beyond the Salon doors.',
  'home.quickTools.encounterTitle': 'A Chance Encounter',
  'home.quickTools.encounterBody': 'Roll the bones and let fate decide who crosses your path at Court.',
  'home.quickTools.encounterResultHeading': 'A Rival Emerges',
  'home.quickTools.encounterSilent': 'The dice tower holds its tongue',
  'home.quickTools.encounterSummoning': 'Beckoning…',
  'home.quickTools.encounterEmpty': 'No rival answered the call. Roll again to tempt fate.',
  'home.quickTools.clockTitle': 'Court Clock',
  'home.quickTools.clockYear': 'Season of the Long Masque',
  'home.quickTools.clockAnno': 'Anno Tenebris {year}',
}
